<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <strong class="card-title mb-3">{{ 'All Scheme Analysis' }} {{ (mfSCHCode != '') ? '-' + mfSCHCode : '' }}
            {{ (rawData.length) ? rawData[0]['SCH_NAME'] : '' }}</strong>
        </div>
        <div class="col-md-5">
        </div>
        <div class="col-md-1">
          <!-- <goback></goback> -->
          <div class="pull-right">
            <router-link class="btn btn-sm" :to="'/mutual-funds/rawdata'"><i class="fa fa-caret-left"></i> Go
              Back</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" id="allSchemeAnalysisPage">
      <div class="row mb5">
        <div class="col-md-6">
        </div>
      </div>
      <vue-tabs v-model="selSchemeTab" direction="horizontal" @tab-change="getTabData">
        <v-tab :title="rd.value" v-for="(rd, index) in rawDataList" v-bind:key="index">
          <div class="mb5"></div>
          <div class="" v-if="rawDataType == 'analysis-sum'">
            <div class="row mb5">
              <div class="col-md-3">
                <span v-if="rawData.date"><strong>Date: {{ rawData.date ? getDate(sum.date) : '' }}</strong></span>
              </div>
              <div class="col-md-3">
                <span v-if="rawData.date">Portfolio Overall Rating: {{ rawData.date ?
                  getChecknFixed(sum.portfolio_overall_rating) : '' }}</span>
              </div>
              <div class="col-md-3">
                <span v-if="rawData.avg_maturity"><strong>Average Maturity:</strong>
                  {{ getChecknFixed(rawData.avg_maturity) }} <br>{{ rawData.avg_maturity_date ?
                    getDate(rawData.avg_maturity_date) : '' }}</span>
              </div>
              <div class="col-md-2">
                <download :tableId="rawDataType" :fileName="rawDataType"></download>
              </div>
            </div>
            <div class="row mb5" v-if="tableFields1.length">
              <div class="col-md-3">
                <div class="form-group">
                  <input type="text" v-model="scheme_name" class="form-control" name="search"
                    placeholder="Search by scheme name">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <input type="text" v-model="searchText" class="form-control" name="search"
                    placeholder="Search by Lname">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <v-select :options="fundManagerList" :placeholder="'Select Fund Manager'" :label="'name'"
                    v-model="selFundManager"></v-select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <input type="text" v-model="category" class="form-control" name="search"
                    placeholder="Search by category">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <input type="text" v-model="searchP11.min" class="form-control" name="search" placeholder="Min P11">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <input type="text" v-model="searchP11.max" class="form-control" name="search" placeholder="Max P11">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <input type="text" v-model="searchp11qtr.min" class="form-control" name="search"
                    placeholder="Min P11 quarterly trends">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <input type="text" v-model="searchp11qtr.max" class="form-control" name="search"
                    placeholder="Max P11 quarterly trends">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <input type="text" v-model="searchq1ab.min" class="form-control" name="search"
                    placeholder="Min Q1 A/B">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <input type="text" v-model="searchq1ab.max" class="form-control" name="search"
                    placeholder="Max Q1 A/B">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <input type="text" v-model="searchPortfolioRating.min" class="form-control" name="search"
                    placeholder="Min Portfolio Ratings">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <input type="text" v-model="searchPortfolioRating.max" class="form-control" name="search"
                    placeholder="Max Portfolio Ratings">
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <button class="btn btn-primary" @click="filterSchemes">Filter</button>
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <button class="btn btn-default" @click="resetFilter">Reset</button>
                </div>
              </div>
            </div>
            <table class="table table-bordered fonts11 app-inner" style="table-layout: fixed;">
              <tr>
                <div class="table-responsive scrollbar app" v-dragscroll="true" v-if="tableFields1.length">
                  <table :id="rawDataType" class="table table-bordered fonts11 app-inner">
                    <thead>
                      <tr>
                        <th v-if="tableFields1.length">Sr.</th>
                        <th class="data-cell" @click="sortColumnByName(field, index)"
                          v-for="(field, index) in tableFields1" v-bind:key="index + 'sumfield' + field.title">
                          <span>{{ field.name }}
                            <i class="fa fa-caret-down" v-if="(field.sort == 1 || field.sort == 0)"></i>
                            <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                          </span>
                        </th>
                        <th v-for="(field, index) in ratings.subFields" v-bind:key="'ratingsth' + field.title + index">
                          {{ field.name }}
                          <i class="fa fa-caret-down" v-if="(field.sort == 1 || field.sort == 0)"></i>
                          <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                        </th>
                      </tr>
                    </thead>
                    <tbody v-if="tableFields1.length">
                      <tr v-for="(tr, ind) in rawData" v-bind:key="'trBod' + '-' + ind">
                        <td>{{ ind + 1 }}</td>
                        <td v-for="(cl, index) in tableFields1" v-bind:key="index + 'cldata' + cl.title">
                          <span v-if="cl.datatype == 'numeric'">{{ (tr[cl.title + '_sum']) ?
                            getChecknFixed(tr[cl.title +
                              '_sum']) :
                            (tr[cl.title]) ? getChecknFixed(tr[cl.title]) : '-' }}</span>
                          <span v-else-if="cl.datatype == 'date'">{{ (tr[cl.title + '_sum']) ? getDate(tr[cl.title +
                            '_sum']) :
                            (tr[cl.title]) ? getDate(tr[cl.title]) : '-' }}</span>
                          <span v-else>{{ (tr[cl.title + '_sum']) ? tr[cl.title + '_sum'] : (tr[cl.title]) ?
                            tr[cl.title]
                            :
                            '' }}</span>
                        </td>
                        <td v-for="(cl, index) in ratings.subFields" v-bind:key="'ratingstd' + cl.title + index">
                          <span v-if="cl.datatype == 'numeric'">
                            {{ (tr['ratings'] && tr['ratings']['raw'] && tr['ratings']['raw'][cl.title]) ?
                              (tr['ratings']['raw'][cl.title]) : '-' }}
                            {{ (tr['ratings'] && tr['ratings']['label'] && tr['ratings']['label'][cl.title]) ?
                              '(' + (tr['ratings']['label'][cl.title]) + ')' : '-' }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </tr>
            </table>


          </div>
          <div v-else-if="rawDataType === 'scheme-rolling-returns'">
            <div class="row mb-5">
              <div class="col-md-4">
                <div class="form-group">
                  <v-select :options="durationForRollingReturns" :placeholder="'Select Duration'" v-model="selDuration"
                    @input="getRollingDuration($event)"></v-select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <v-select :options="durDateList" :placeholder="'Select Date'" v-model="durDate"
                    @input="getDateData($event)"></v-select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <button class="btn btn-sm" @click="downLoadAll">Download</button>
                </div>
              </div>
            </div>
          </div>
          <!-- ROLLING RETURNS UPDATE RECORD: START -->
          <div v-else-if="rawDataType === 'rolling-return-update-record'">
            <div class="row mb-5 rolling-return-update-record">
              <!--  <div class="col-md-4">
                <div class="form-group">
                  <v-select :options="durationForRollingReturns" :placeholder="'Select Duration'" v-model="selDuration"
                    @input="getRollingDuration($event)"></v-select>
                </div>
              </div> -->
              <div class="col-md-3">
                <div class="form-group" style="width: max-content;">
                  <v-select :options="rollingReturnDateList" :placeholder="'Select Date'" :label="'date'"
                    v-model="durDate" @input="filterRollingResultByDateData($event)"></v-select>
                </div>
              </div>
              <div class="col-md-9">
                <div v-if="selectedRollingReturnData.length > 0">
                  <download :tableId="rawDataType" :fileName="rawDataType"></download>
                </div>
              </div>

              <table class="table table-bordered fonts11 app-inner ml-3 mr-3" style="table-layout: fixed;">
                <tr>
                  <div class="table-responsive mb-15 app" v-if="selectedRollingReturnData.length > 0">
                    <table :id="rawDataType" class="table table-bordered fonts11 app-inner">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>MF-Code</th>
                          <th v-if="selectedRollingReturnData[0].error_mf_code.length > 0">
                            Error-MF-Code</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(tr, ind) in selectedRollingReturnData" v-bind:key="'rolling-return' + '-' + ind">
                          <td>
                            <span class="analysis-sum-scheme-code-date">{{ tr.date }}</span>
                          </td>
                          <td>
                            <span v-for="(mfCode, mfIdx) in tr.mf_code">
                              <span v-if="mfIdx + 1 % 30 === 0"><br>{{ mfCode }},</span>
                              <span else>{{ mfCode }},</span>
                            </span>
                          </td>
                          <td v-if="selectedRollingReturnData[0].error_mf_code.length > 0">
                            <span v-for="(mfErrorCode, mfErIdx) in tr.error_mf_code">
                              <span v-if="mfErIdx + 1 % 30 === 0"><br>{{ mfErrorCode }},</span>
                              <span else>{{ mfErrorCode }},</span>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </tr>
              </table>


            </div>
          </div>
          <!-- ROLLING RETURNS UPDATE RECORD: END -->

          <div v-else-if="rawDataType === 'scheme-ratings'">
            <div class="row mb-5">
              <div class="col-md-3">
                <div class="form-group">
                  <!-- <datepicker
                    :input-class="'form-control'"
                    :format="'dd-MM-yyyy'"
                    v-model="durDate"
                    @selected="getDateData($event)"
                    :disabledDates="disabledDates"
                    :placeholder="'Select Date'"
                  ></datepicker> -->
                  <v-select :options="durDateList" :placeholder="'Select Date'" v-model="durDate"
                    @input="getDateData($event)"></v-select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <button class="btn btn-sm" @click="downLoadAll">Download</button>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="rawDataType === 'scheme-master'">
            <div class="row mb-5">
              <div class="col-md-3">
                <div class="form-group">
                  <v-select :options="durDateList" :placeholder="'Select Date'" v-model="durDate"
                    @input="getDateData($event)"></v-select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <button class="btn btn-sm" @click="downLoadAll">Download</button>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="rawDataType === 'mf-rank-summery'">
            <div class="row mb-5">
              <div class="col-md-3">
                <div class="form-group">
                  <v-select :options="durDateList" :placeholder="'Select Date'" v-model="durDate"
                    @input="getDateData($event)"></v-select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <button class="btn btn-sm" @click="downLoadAll">Download</button>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="rawDataType === 'mf-consolidate'">
            <div class="row mb-5">
              <div class="col-md-3">
                <div class="form-group">
                  <!-- <datepicker
                    :input-class="'form-control'"
                    :format="'dd-MM-yyyy'"
                    v-model="durDate"
                    @selected="getDateData($event)"
                    :disabledDates="disabledDates"
                    :placeholder="'Select Date'"
                  ></datepicker> -->
                  <v-select :options="durDateList" :placeholder="'Select Date'" v-model="durDate"
                    @input="getDateData($event)"></v-select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <button class="btn btn-sm" @click="downLoadAll">Download</button>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="rawDataType === 'mf-recommanded'">
            <div class="row mb-5">
              <div class="col-md-3">
                <div class="form-group">
                  <v-select :options="durDateList" :placeholder="'Select Date'" v-model="durDate"
                    @input="getDateData($event)"></v-select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <button class="btn btn-sm" @click="downLoadAll">Download</button>
                </div>
              </div>
            </div>
          </div>
          <!-- Analysis Sum Updated Scheme: START -->
          <div v-else-if="rawDataType === 'analysis-sum-updated-scheme'" class="mt-4">
            <div class="row mb-5">
              <div class="col-md-3">
                <div class="form-group">
                  <v-select :options="analysisSumUpdatedDateList" :placeholder="'Select Date'" :label="'date'"
                    v-model="durDate" @input="filterAnalysisByDateData($event)"></v-select>
                </div>
              </div>
              <div class="col-md-9">
                <div v-if="selectedAnalysisSumUpdatedData.length > 0">
                  <download :tableId="rawDataType" :fileName="rawDataType"></download>
                </div>
              </div>

              <table class="table table-bordered fonts11 app-inner ml-3 mr-3" style="table-layout: fixed;">
                <tr>
                  <div class="table-responsive mb-15 app" v-if="selectedAnalysisSumUpdatedData.length > 0">
                    <table :id="rawDataType" class="table table-bordered fonts11 app-inner">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>MF-Code</th>
                          <th v-if="selectedAnalysisSumUpdatedData[0].error_mf_code.length > 0">
                            Error-MF-Code</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(tr, ind) in selectedAnalysisSumUpdatedData" v-bind:key="'analysis' + '-' + ind">
                          <td>
                            <span class="analysis-sum-scheme-code-date">{{ tr.date }}</span>
                          </td>
                          <td>
                            <span v-for="(mfCode, mfIdx) in tr.mf_code">
                              <span v-if="mfIdx + 1 % 30 === 0"><br>{{ mfCode }},</span>
                              <span else>{{ mfCode }},</span>
                            </span>
                          </td>
                          <td v-if="selectedAnalysisSumUpdatedData[0].error_mf_code.length > 0">
                            <span v-for="(mfErrorCode, mfErIdx) in tr.error_mf_code">
                              <span v-if="mfErIdx + 1 % 30 === 0"><br>{{ mfErrorCode }},</span>
                              <span else>{{ mfErrorCode }},</span>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </tr>
              </table>
            </div>
          </div>
          <!-- Analysis Sum Updated Scheme: END -->

          <!-- Recommended Main Category : START -->
          <div class=""
            v-else-if="rawDataType == 'Recommended_MainCategory' || rawDataType == 'Recommended_Category' || rawDataType == 'Recommended_Fund_House' || rawDataType == 'Recommended_Fund_Manager'">
            <div class="row mb5">
              <Recommended :rawData="recommendedCategoryData" />
            </div>
          </div>
          <!-- Recommended Main Category : END -->
        </v-tab>
      </vue-tabs>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";
import StarRating from "vue-star-rating";
import Datepicker from "vuejs-datepicker";

import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { rawMixins } from "../../assets/mixins/rawMixins.js";
import Recommended from "./recommended";


export default {
  components: { VueTabs, VTab, StarRating, Datepicker, Recommended },
  mixins: [commonMixins, rawMixins],
  created() {
    console.log('PARAM', this.$route.params.id);
    if (this.$route.params.id) {
      this.showSchemeHoldings(this.$route.params.id);
      this.mfSCHCode = this.$route.params.id;
    } else {
      this.rawData = [];
      this.getFundManagerList();
      this.showSchemeHoldings();
    }
    console.log("Rawtype", this.rawDataType, this.mfSCHCode);
  },
  methods: {
    showSchemeHoldings(mfcode = null) {
      console.log('mfcode', mfcode, this.rawDataApi);
      if (!this.isApiCalled) {
        this.rawData = [];
        this.isApiCalled = 1;
        // this.tableFields = [];
        let myself = this;
        var APIUrl = this.rawDataApi + 'analysis-sum';
        if (mfcode != null) {
          APIUrl = APIUrl + '/' + mfcode;
          if (this.durDate != null) {
            APIUrl = APIUrl + '?date=' + this.getYMDDate(this.durDate);
          }
        }
        http.get(APIUrl, {}, (error, response) => {
          console.log("Response", response.data);
          if (response.status == 'success') {
            this.rawData = response.data.date ? response.data : response.data;
            this.searchData = this.rawData;
            this.sum = response.data.date ? response.data : [];
            console.log(this.rawData);
            this.isApiCalled = 0;
          }
        });
      }
    },
    search() {
      // console.log(this.searchP11);
      this.rawData = this.searchData.filter(rd => {
        console.log(rd);
        var searchTxt, schName, cat, funMng, rating, q1ab, p11, p11qtr = false;
        if ((this.searchText.length > 2 && rd.LNAME))
          searchTxt = rd.LNAME.toLowerCase().includes(this.searchText.toLowerCase());
        if ((this.scheme_name.length > 2 && rd.sch_name))
          schName = rd.LNAME.toLowerCase().includes(this.scheme_name.toLowerCase());
        if ((this.category.length > 2 && rd.Category))
          cat = rd.Category.toLowerCase().includes(this.category.toLowerCase());
        if ((this.selFundManager != null && rd['FundManager']))
          funMng = rd['FundManager'].toLowerCase() == this.selFundManager.name.toLowerCase();
        if (this.searchPortfolioRating.max.length > 1 && this.searchPortfolioRating.min.length > 1 && rd['portfolio_overall_rating']) {
          rating = (rd['portfolio_overall_rating'] >= parseFloat(this.searchPortfolioRating.min) && rd['portfolio_overall_rating'] < parseFloat(this.searchPortfolioRating.max));
        } else if (this.searchPortfolioRating.min.length > 1 && rd['portfolio_overall_rating']) {
          rating = (rd['portfolio_overall_rating'] >= parseFloat(this.searchPortfolioRating.min));
        } else {
          rating = (rd['portfolio_overall_rating'] <= parseFloat(this.searchPortfolioRating.max));
        }
        if (this.searchq1ab.max.length > 1 && this.searchq1ab.min.length > 1 && rd['q1_a_b_greater_%_hldg_sum']) {
          q1ab = (rd['q1_a_b_greater_%_hldg_sum'] >= parseFloat(this.searchq1ab.min) && rd['q1_a_b_greater_%_hldg_sum'] < parseFloat(this.searchq1ab.max));
        } else if (this.searchq1ab.min.length > 1 && rd['q1_a_b_greater_%_hldg_sum']) {
          q1ab = (rd['q1_a_b_greater_%_hldg_sum'] >= parseFloat(this.searchq1ab.min));
        } else {
          q1ab = (rd['q1_a_b_greater_%_hldg_sum'] <= parseFloat(this.searchq1ab.max));
        }
        if (this.searchp11qtr.max.length > 1 && this.searchp11qtr.min.length > 1 && rd['p11_quarterly_trends_%_hldg_sum']) {
          p11qtr = (rd['p11_quarterly_trends_%_hldg_sum'] >= parseFloat(this.searchp11qtr.min) && rd['p11_quarterly_trends_%_hldg_sum'] < parseFloat(this.searchp11qtr.max));
        } else if (this.searchp11qtr.min.length > 1 && rd['p11_quarterly_trends_%_hldg_sum']) {
          p11qtr = (rd['p11_quarterly_trends_%_hldg_sum'] >= parseFloat(this.searchp11qtr.min));
        } else {
          p11qtr = (rd['p11_quarterly_trends_%_hldg_sum'] <= parseFloat(this.searchp11qtr.max));
        }
        if (this.searchP11.max.length > 1 && this.searchP11.min.length > 1 && rd['p11_S_%_hldg_sum']) {
          p11 = (rd['p11_S_%_hldg_sum'] >= parseFloat(this.searchP11.min) && rd['p11_S_%_hldg_sum'] < parseFloat(this.searchP11.max));
        } else if (this.searchP11.min.length > 1 && rd['p11_S_%_hldg_sum']) {
          p11 = (rd['p11_S_%_hldg_sum'] >= parseFloat(this.searchP11.min));
        } else {
          p11 = (rd['p11_S_%_hldg_sum'] <= parseFloat(this.searchP11.max));
        }
        return (searchTxt || schName || cat || funMng || rating || q1ab || p11 || p11qtr);
      });
      // }
    },
    getFundManagerList() {
      let _this = this;
      http.get("mutual-funds/fund-manager", {}, function (error, response) {
        if (response.status == 'success') {
          var fundManagerList = response.data;
          var uniqueFundManagers = [];
          if (fundManagerList.length > 0) {
            fundManagerList.forEach((fundManager) => {
              if (_this.checkNotInArray(uniqueFundManagers, fundManager.fund_mgr)) {
                uniqueFundManagers.push(fundManager.fund_mgr);
                _this.fundManagerList.push({ name: fundManager.fund_mgr, fund_manager: fundManager.fund_mgr });
              }
            });
            _this.fundManagerList = _this.sorted_fields_asc(
              _this.fundManagerList,
              "name"
            );
            // if (!localStorage.getItem("selFundManager")) {
            //   _this.selFundManager = _this.fundManagerList[0];
            //   localStorage.setItem("selFundManager", JSON.stringify(_this.selFundManager));
            // } else {
            //   _this.selFundManager = JSON.parse(localStorage.getItem("selFundManager"));
            // }
            console.log("Selected FundManager", typeof _this.selFundManager, _this.fundManagerList);
          }
        }
      });
    },
    filterSchemes() {
      console.log(this.selFundManager, this.selFundManager != null);
      if (this.scheme_name.length > 1 || this.selFundManager != null || this.category.length > 1 || this.searchText.length > 1
        || this.searchP11.min.length > 1 || this.searchp11qtr.min.length > 1 || this.searchq1ab.min.length > 1 || this.searchPortfolioRating.min.length > 1
        || this.searchP11.max.length > 1 || this.searchp11qtr.max.length > 1 || this.searchq1ab.max.length > 1 || this.searchPortfolioRating.max.length > 1) {
        this.search();
        console.log('Search');
      } else {
        this.rawData = this.searchData;
      }
    },
    resetFilter() {
      this.selFundManager = null;
      this.scheme_name = this.category = this.searchText = '';
      this.searchP11 = this.searchp11qtr = this.searchq1ab = this.searchPortfolioRating = { min: '', max: '' };
      this.rawData = this.searchData;
    },
    getDateData(e) {
      console.log("Date Selected", e);
      this.durDate = e;
      if (this.rawDataType == 'analysis-sum') {
        this.showSchemeHoldings();
      }
    },
    filterAnalysisByDateData(e) {
      this.durDate = e;
      if (e !== null) {
        //error_mf_code
        let selAnalysisData = this.analysisSumUpdatedData[e.id];
        let collectedAnalysisData = { _id: selAnalysisData._id, date: selAnalysisData.date, mf_code: selAnalysisData.mf_code, error_mf_code: selAnalysisData.error_mf_code != undefined ? selAnalysisData.error_mf_code : [] };
        this.selectedAnalysisSumUpdatedData[0] = collectedAnalysisData;
      } else {
        this.selectedAnalysisSumUpdatedData = [];
      }
      //console.log("Analysis Date Selected: ", this.selectedAnalysisSumUpdatedData);
    },
    filterRollingResultByDateData(e) {
      this.durDate = e;
      if (e !== null) {
        //error_mf_code
        let selAnalysisData = this.rollingReturnUpdateData[e.id];
        let collectedAnalysisData = { _id: selAnalysisData._id, date: selAnalysisData.date, mf_code: selAnalysisData.mf_code, error_mf_code: selAnalysisData.error_mf_code != undefined ? selAnalysisData.error_mf_code : [] };
        this.selectedRollingReturnData[0] = collectedAnalysisData;
      } else {
        this.selectedRollingReturnData = [];
      }
    },
    getAnalysisSumUpdatedSchemeData() {

      let apiUrl = "/mutual-funds/analysis-sum-update-record/1";
      let self = this;
      console.log('## getAnalysisSumUpdatedSchemeData:::', apiUrl);
      http.get(apiUrl, {}, (error, response) => {
        console.log("date response: ", response);
        if (response.status === 'success') {
          self.analysisSumUpdatedData = response.data;
          self.analysisSumUpdatedData.forEach((itemKey, idx) => {
            self.analysisSumUpdatedDateList.push({ id: idx, date: itemKey.date });
          });
          //console.log('self.analysisSumUpdatedData:::', self.analysisSumUpdatedData);
          //console.log('self.analysisSumUpdatedDateList :::', self.analysisSumUpdatedDateList);
        }
      });
    },
    getRecommendedCategoryData() {

      let self = this;
      let apiUrl = "/frontend/profile_allocation_recommended_to_diff/get";
      let data = { "collection_name": this.rawDataType };
      //console.log('TAB::: >>> ', this.rawDataType)
      //return;
      http.post(apiUrl, data, (error, response) => {
        console.log("date response: ", response);
        if (response.responseType === 'success') {
          self.recommendedCategoryData = response.data;
        }
      });
    },
    getRollingReturnUpdateRecord() {
      //mutual-funds/rolling-return-update-record
      let apiUrl = this.rawDataApi + "rolling-return-update-record";
      let self = this;

      http.get(apiUrl, {}, (error, response) => {
        console.log("date response: ", response);
        self.rollingReturnDateList = [];
        if (response.status === 'success') {
          self.rollingReturnUpdateData = response.data;
          console.log('rolling-return-update-record >>>', self.rollingReturnUpdateData);
          self.rollingReturnUpdateData.forEach((itemKey, idx) => {
            self.rollingReturnDateList.push({ id: idx, date: itemKey.date });
          });
        }
      });
    },
    getNewDateData() {

      //"http://localhost:5002/mutual-funds/filter-date?collection_name=mf-recommendated&collection_name=mf-ranks"
      //let dateURL = "http://localhost:5002/mutual-funds/filter-date?collection_name=mf-recommendated&collection_name=mf-ranks";
      //rawDataApi: "mutual-funds/",
      //filter-date?collection_name=mf-recommendated
      console.log('## currentTabName:::', this.rawDataType);

      let apiUrl = this.rawDataApi + "filter-date?collection_name=";

      if (this.rawDataType == 'mf-rank-summery') {
        apiUrl = apiUrl + 'mf-ranks';
      } else if (this.rawDataType == 'mf-consolidate') {
        apiUrl = apiUrl + 'mf-consolidate';
      } else if (this.rawDataType == 'mf-recommanded') {
        apiUrl = apiUrl + 'mf-recommendated';
      } else if (this.rawDataType == 'scheme-rolling-returns') {
        apiUrl = apiUrl + 'scheme-rolling-returns';
      } else if (this.rawDataType == 'scheme-master') {
        apiUrl = apiUrl + 'master';
      } else if (this.rawDataType == 'scheme-ratings') {
        apiUrl = apiUrl + 'analysis-sum';
      }

      //http://localhost:5002/mutual-funds/filter-date?collection_name=scheme-rolling-returns
      //mutual-funds/rolling-return-update-record

      http.get(apiUrl, {}, (error, response) => {
        console.log("date response: ", response);
        if (response.responseType === 'success') {
          this.durDateList = response.date;
          this.durDateList.map((date, index) => {
            console.log("* ", date, date.split('T')[0])
            this.durDateList[index] = date.split('T')[0];
          });
        }
      });

    },
    showSchemeRollingReturns() {
      this.isDownload = 0;
      this.durDate = null;
    },
    downLoadAll() {
      if (!this.isApiCalled) {
        this.isDownload = 1;
        let apiUrl = this.rawDataApi;
        if (this.rawDataType == 'scheme-rolling-returns') {
          apiUrl = apiUrl + this.rawDataType;
          apiUrl = apiUrl + '?allSchemesDownload=1';
          apiUrl = apiUrl + '&duration=' + this.selDuration;
          if (this.durDate != null) {
            apiUrl = apiUrl + '&date=' + this.getYMDDate(this.durDate);
          }
        } else if (this.rawDataType == 'scheme-ratings') {
          apiUrl = apiUrl + 'analysis-sum?download=1';
          if (this.durDate != null) {
            apiUrl = apiUrl + '&date=' + this.getYMDDate(this.durDate);
          }
        } else if (this.rawDataType == 'scheme-master') {
          apiUrl = apiUrl + 'scheme-master?download=1';
          if (this.durDate != null) {
            apiUrl = apiUrl + '&date=' + this.getYMDDate(this.durDate);
          }
        } else if (this.rawDataType == 'mf-rank-summery') {
          apiUrl = apiUrl + 'all-mf-ranks?download=1';
          console.log("Date: ", this.getDate(this.durDate), this.getDDDate(this.durDate), this.getYMDDate(this.durDate), this.getFormattedDate(this.durDate))
          if (this.durDate != null) {
            apiUrl = apiUrl + '&recommend_date=' + this.durDate;//this.getYMDDate(this.durDate);
          }
        } else if (this.rawDataType == 'mf-consolidate') {
          apiUrl = apiUrl + 'mf-consolidate?download=1';
          if (this.durDate != null) {
            apiUrl = apiUrl + '&recommend_date=' + this.getYMDDate(this.durDate);
          }
        } else if (this.rawDataType == 'mf-recommanded') {
          apiUrl = apiUrl + 'new-mf-recommendated?download=1';
          if (this.durDate != null) {
            apiUrl = apiUrl + '&recommend_date=' + this.getYMDDate(this.durDate);
          }
        }
        http.get(apiUrl, {}, (error, response) => {
          this.isApiCalled = 0;
          if (response.responseType === 'success') {
            this.isDownload = 0;
            this.isApiCalled = 0;
            window.open(response.download_link, '_blank');
          }
        });
      }
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log(this.selRowInd, tabIndex, this.selRowInd != tabIndex);
      console.log("TabChange", this.selRowInd, tabIndex, newTab, oldTab, this.rawDataList);
      this.selectedAnalysisSumUpdatedData = [];
      this.selectedRollingReturnData = [];
      this.analysisSumUpdatedData = [];
      this.analysisSumUpdatedDateList = [];
      this.rollingReturnDateList = [];

      if (this.selRowInd != tabIndex) {
        this.clearPagination();
        this.ratings.subFields = [];
        this.rawDataList[this.selRowInd].open = false;
        this.selRowInd = tabIndex;
        this.rawDataType = this.rawDataList[tabIndex].id;
        this.selSchemeTab = this.rawDataList[tabIndex].value;
        this.resetFilter();
        this.getRawData();
      } else if (this.selRowInd == tabIndex) {
        this.selRowInd = tabIndex;
      }
    },
    clearPagination() {
      this.page = 1;
      this.current_page = 1;
      this.pageToLoad = 1;
      this.totalPages = 1;
      this.prevDisabled = 1;
      this.nextDisabled = 0;
      this.pages = [];
      this.durDate = null;
    },
    getRawData() {
      console.log('currentTabName:::', this.rawDataType);
      if (this.rawDataType == 'analysis-sum') {
        this.showSchemeHoldings();
      } else if (this.rawDataType == 'scheme-master') {
        this.showSchemeRollingReturns();
        this.getNewDateData();
      } else if (this.rawDataType == 'scheme-rolling-returns') {
        this.showSchemeRollingReturns();
        this.getNewDateData();
      } else if (this.rawDataType == 'rolling-return-update-record') {
        //this.showSchemeRollingReturns();
        //this.getNewDateData();
        this.getRollingReturnUpdateRecord();
      } else if (this.rawDataType == 'scheme-ratings') {
        this.showSchemeRollingReturns();
        this.getNewDateData();
      } else if (this.rawDataType == 'mf-rank-summery' || this.rawDataType == 'mf-consolidate' || this.rawDataType == 'mf-recommanded') {
        this.getNewDateData();
      } else if (this.rawDataType === 'analysis-sum-updated-scheme') {
        this.getAnalysisSumUpdatedSchemeData();
      } else if (this.rawDataType === 'Recommended_MainCategory' || this.rawDataType === 'Recommended_Category' || this.rawDataType === 'Recommended_Fund_House' || this.rawDataType === 'Recommended_Fund_Manager') {
        this.getRecommendedCategoryData();
      }
    },

    getRollingDuration(e) {
      console.log('Selected Duration', e);
      this.selDuration = e;
    },
  },
  data() {
    return {
      rawDataList: [
        { id: "analysis-sum", value: "Analysis Sum ", open: false, items: {}, isPaginate: 0 },
        { id: "scheme-rolling-returns", value: "Rolling Returns", open: false, items: {}, isPaginate: 0 },
        { id: "rolling-return-update-record", value: "Rolling Return Update Record", open: false, items: {}, isPaginate: 0 },
        { id: "scheme-ratings", value: "Ratings", open: false, items: {}, isPaginate: 0 },
        { id: "scheme-master", value: "Master", open: false, items: {}, isPaginate: 0 },
        { id: "mf-rank-summery", value: "MF-RANK-SUMMARY", open: false, items: {}, isPaginate: 0 },
        { id: "mf-consolidate", value: "MF-CONSOLIDATE", open: false, items: {}, isPaginate: 0 },
        { id: "mf-recommanded", value: "MF-RECOMMANDED", open: false, items: {}, isPaginate: 0 },
        { id: "analysis-sum-updated-scheme", value: "Analysis Sum Updated Scheme", open: false, items: {}, isPaginate: 0 },
        { id: "Recommended_MainCategory", value: "Recommended_MainCategory", open: false, items: {}, isPaginate: 0 },
        { id: "Recommended_Category", value: "Recommended_Category", open: false, items: {}, isPaginate: 0 },
        { id: "Recommended_Fund_House", value: "Recommended_Fund_House", open: false, items: {}, isPaginate: 0 },
        { id: "Recommended_Fund_Manager", value: "Recommended_Fund_Manager", open: false, items: {}, isPaginate: 0 },

      ],
      recommendedCategoryData: [],
      durDateList: [],
      rollingReturnDateList: [],
      selectedAnalysisSumUpdatedData: [],
      selectedRollingReturnData: [],
      analysisSumUpdatedData: [],
      analysisSumUpdatedDateList: [],
      selSchemeTab: "",
      selRowInd: 0,
      durationForRollingReturns: ["3M", "1Y", "3Y", "5Y"],
      selDuration: '3M',
      durDate: null,
      selScheme: '',
      // durDate: new Date().setDate(new Date().getDate() - 1),
      disabledDates: {
        from: new Date(new Date().setDate(new Date().getDate() - 1))
      },
      isDownload: 0,
      isApiCalled: 0,
      tableFields1: [
        {
          title: 'mf_schcode',
          name: this.getCustomLabel('mf_schcode') ? this.getCustomLabel('mf_schcode') : this.getLabel('mf_schcode'),
          isLink: 0,
          datatype: 'string',
          sort_order: 1,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'date',
          name: this.getCustomLabel('date') ? this.getCustomLabel('date') : this.getLabel('date'),
          isLink: 0,
          datatype: 'date',
          sort_order: 2,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'MF_COCODE',
          name: this.getCustomLabel('MF_COCODE') ? this.getCustomLabel('MF_COCODE') : this.getLabel('MF_COCODE'),
          isLink: 0,
          datatype: 'string',
          sort_order: 3,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'LNAME',
          name: this.getCustomLabel('LNAME') ? this.getCustomLabel('LNAME') : this.getLabel('LNAME'),
          isLink: 0,
          datatype: 'string',
          sort_order: 4,
          sort: 0,
          isSortable: 1,
          isNumeric: 0
        },
        {
          title: 'sch_name',
          name: this.getCustomLabel('sch_name') ? this.getCustomLabel('sch_name') : this.getLabel('sch_name'),
          isLink: 0,
          datatype: 'string',
          sort_order: 5,
          sort: 0,
          isSortable: 1,
          isNumeric: 0
        },
        {
          title: 'Category',
          name: this.getCustomLabel('Category') ? this.getCustomLabel('Category') : this.getLabel('Category'),
          isLink: 0,
          datatype: 'string',
          sort_order: 6,
          sort: 0,
          isSortable: 1,
          isNumeric: 0
        },
        {
          title: 'FundManager',
          name: this.getCustomLabel('FundManager') ? this.getCustomLabel('FundManager') : this.getLabel('FundManager'),
          isLink: 0,
          datatype: 'string',
          sort_order: 7,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'scheme_ratios_date',
          name: this.getCustomLabel('scheme_ratios_date') ? this.getCustomLabel('scheme_ratios_date') : this.getLabel('scheme_ratios_date'),
          isLink: 0,
          datatype: 'date',
          sort_order: 8,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'ALPHA',
          name: this.getCustomLabel('ALPHA') ? this.getCustomLabel('ALPHA') : this.getLabel('ALPHA'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 9,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'BETA',
          name: this.getCustomLabel('BETA') ? this.getCustomLabel('BETA') : this.getLabel('BETA'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 10,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'AVERAGE',
          name: this.getCustomLabel('AVERAGE') ? this.getCustomLabel('AVERAGE') : this.getLabel('AVERAGE'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 11,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'NAV',
          name: this.getCustomLabel('NAV') ? this.getCustomLabel('NAV') : this.getLabel('NAV'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 12,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'RSQUARE',
          name: this.getCustomLabel('RSQUARE') ? this.getCustomLabel('RSQUARE') : this.getLabel('RSQUARE'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 13,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'SD',
          name: this.getCustomLabel('SD') ? this.getCustomLabel('SD') : this.getLabel('SD'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 14,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'SHARPE',
          name: this.getCustomLabel('SHARPE') ? this.getCustomLabel('SHARPE') : this.getLabel('SHARPE'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 15,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'SchemeAUM',
          name: this.getCustomLabel('SchemeAUM') ? this.getCustomLabel('SchemeAUM') : this.getLabel('SchemeAUM'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 16,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'scheme_returns_date',
          name: this.getLabel('returns_date'),
          isLink: 0,
          datatype: 'date',
          sort_order: 17,
          sort: 0,
          isSortable: 1
        },
        {
          title: '1month',
          name: this.getLabel('1 M'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 18,
          sort: 0,
          isSortable: 1
        },
        {
          title: '3month',
          name: this.getLabel('3 M'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 19,
          sort: 0,
          isSortable: 1
        },
        {
          title: '6month',
          name: this.getLabel('6 M'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 20,
          sort: 0,
          isSortable: 1
        },
        {
          title: '1year',
          name: this.getLabel('1 Yr'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 21,
          sort: 0,
          isSortable: 1
        },
        {
          title: '3year',
          name: this.getLabel('3 Yrs'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 22,
          sort: 0,
          isSortable: 1
        },
        {
          title: '5year',
          name: this.getLabel('5 Yrs'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 23,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'inception',
          name: this.getLabel('inception'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 23,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'EXPRATIO',
          name: this.getLabel('Exp Ratio'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 24,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p1_S_%_hldg',
          name: this.getCustomLabel('p1_S_%_hldg') ? this.getCustomLabel('p1_S_%_hldg') : this.getLabel('p1_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 25,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p2_S_%_hldg',
          name: this.getCustomLabel('p2_S_%_hldg') ? this.getCustomLabel('p2_S_%_hldg') : this.getLabel('p2_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 26,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'p3_S_%_hldg',
          name: this.getCustomLabel('p3S_%_hldg') ? this.getCustomLabel('p3S_%_hldg') : this.getLabel('p3S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 27,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'p4_S_%_hldg',
          name: this.getCustomLabel('p4_S_%_hldg') ? this.getCustomLabel('p4_S_%_hldg') : this.getLabel('p4_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 28,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'p5_a_S_%_hldg',
          name: this.getCustomLabel('p5_a_S_%_hldg') ? this.getCustomLabel('p5_a_S_%_hldg') : this.getLabel('p5_a_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 29,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'p5_b_S_%_hldg',
          name: this.getCustomLabel('p5_b_S_%_hldg') ? this.getCustomLabel('p5_b_S_%_hldg') : this.getLabel('p5_b_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 30,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'p6_a_%_hldg',
          name: this.getCustomLabel('p6_a_%_hldg') ? this.getCustomLabel('p6_a_%_hldg') : this.getLabel('p6_a_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 31,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'p7_a_S_%_hldg',
          name: this.getCustomLabel('p7_a_S_%_hldg') ? this.getCustomLabel('p7_a_S_%_hldg') : this.getLabel('p7_a_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 32,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'p7_b_S_%_hldg',
          name: this.getCustomLabel('p7_b_S_%_hldg') ? this.getCustomLabel('p7_b_S_%_hldg') : this.getLabel('p7_b_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 33,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'p8_a_S_%_hldg',
          name: this.getCustomLabel('p8_a_S_%_hldg') ? this.getCustomLabel('p8_a_S_%_hldg') : this.getLabel('p8_a_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 34,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'p8_b_S_%_hldg',
          name: this.getCustomLabel('p8_b_S_%_hldg') ? this.getCustomLabel('p8_b_S_%_hldg') : this.getLabel('p8_b_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 35,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'p9_S_%_hldg',
          name: this.getCustomLabel('p9_S_%_hldg') ? this.getCustomLabel('p9_S_%_hldg') : this.getLabel('p9_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 36,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'p10_S_%_hldg',
          name: this.getCustomLabel('p10_S_%_hldg') ? this.getCustomLabel('p10_S_%_hldg') : this.getLabel('p10_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 37,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'p11_debt_%_hldg',
          name: this.getLabel('p11_debt_rating_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 35
        },
        {
          title: 'p11_S_%_hldg',
          name: this.getCustomLabel('p11_S_%_hldg') ? this.getCustomLabel('p11_S_%_hldg') : this.getLabel('p11_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 38,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'p11_quarterly_trends_%_hldg',
          name: this.getCustomLabel('p11_quarterly_trends_%_hldg') ? this.getCustomLabel('p11_quarterly_trends_%_hldg') : this.getLabel('p11_quarterly_trends_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 39,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'q1_S_%_hldg',
          name: this.getCustomLabel('q1_S_%_hldg') ? this.getCustomLabel('q1_S_%_hldg') : this.getLabel('q1_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 40,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'q1_a_S_%_hldg',
          name: this.getCustomLabel('q1_a_S_%_hldg') ? this.getCustomLabel('q1_a_S_%_hldg') : this.getLabel('q1_a_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 42,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'q1_b_S_%_hldg',
          name: this.getCustomLabel('q1_b_S_%_hldg') ? this.getCustomLabel('q1_b_S_%_hldg') : this.getLabel('q1_b_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 44,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'q1_a_b_greater_%_hldg',
          name: this.getCustomLabel('q1_a_b_greater_%_hldg') ? this.getCustomLabel('q1_a_b_greater_%_hldg') : this.getLabel('q1_a_b_greater_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 46,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'q1_c_S_%_hldg',
          name: this.getCustomLabel('q1_c_S_%_hldg') ? this.getCustomLabel('q1_c_S_%_hldg') : this.getLabel('q1_c_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 48,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'q1_d_S_%_hldg',
          name: this.getCustomLabel('q1_d_S_%_hldg') ? this.getCustomLabel('q1_d_S_%_hldg') : this.getLabel('q1_d_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 50,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
        {
          title: 'portfolio_overall_rating',
          name: this.getLabel('portfolio_overall_rating') ? this.getLabel('portfolio_overall_rating') : this.getLabel('portfolio_overall_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 51,
          sort: 0,
          isSortable: 1,
          isNumeric: 1
        },
      ],
      ratings:
      {
        title: 'ratings',
        name: 'Ratings',
        datatype: 'numeric',
        sort_order: 51,
        sort: 0,
        isSortable: 1,
        subFields: [
          {
            title: 'p11_S_%_hldg',
            name: this.getCustomLabel('p11_S_%_hldg') ? this.getCustomLabel('p11_S_%_hldg') : this.getLabel('p11_S_%_hldg'),
            datatype: 'numeric',
            sort_order: 51,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p11_quarterly_trends_%_hldg',
            name: this.getCustomLabel('p11_quarterly_trends_%_hldg') ? this.getCustomLabel('p11_quarterly_trends_%_hldg') : this.getLabel('p11_quarterly_trends_%_hldg'),
            datatype: 'numeric',
            sort_order: 52,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'q1_a_b_greater_%_hldg',
            name: this.getCustomLabel('q1_a_b_greater_%_hldg') ? this.getCustomLabel('q1_a_b_greater_%_hldg') : this.getLabel('q1_a_b_greater_%_hldg'),
            datatype: 'numeric',
            sort_order: 53,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p11_debt_%_hldg',
            name: this.getCustomLabel('p11_debt_%_hldg') ? this.getCustomLabel('p11_debt_%_hldg') : this.getLabel('p11_debt_%_hldg'),
            datatype: 'numeric',
            sort_order: 54,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'portfolio_overall_rating',
            name: this.getCustomLabel('portfolio_overall_rating') ? this.getCustomLabel('portfolio_overall_rating') : this.getLabel('portfolio_overall_rating'),
            datatype: 'numeric',
            sort_order: 55,
            sort: 0,
            isSortable: 1
          }
        ]
      },
      sum: {},
      searchText: '',
      selFundManager: null,
      fundManagerList: [],
      scheme_name: '',
      category: '',
      searchP11: { min: '', max: '' },
      searchp11qtr: { min: '', max: '' },
      searchq1ab: { min: '', max: '' },
      searchPortfolioRating: { min: '', max: '' },
      rawDataType: "analysis-sum",
      rawDataApi: "mutual-funds/",
      rawData: [],
      valueGrowthData: [],
      searchData: [],
      mfSCHCode: '',
    };
  },
  computed: {
    // mfHoldingData: function() {
    //   return this.rawData.filter(function(row, index) {
    //     return index !== "_id" && index !== "co_code";
    //   });
    // },
    // keyFinancialRatios: function(){
    //   return (this.rawData.length > 0 && this.rawData[0]['keyfinancialratiolist'])? this.rawData[0]['keyfinancialratiolist']: [];
    // }
  }
};
</script>
<style scoped>


form .col-md-3 {
  width: 40%;
}

#allSchemeAnalysisPage .table td {
  padding: 5px 10px 5px 10px;
  white-space: nowrap;
}

#allSchemeAnalysisPage .table thead th {
  white-space: nowrap;
}

.analysis-sum-scheme-code {
  display: block;
  width: 400px;
  word-wrap: break-word;
}

.analysis-sum-scheme-code-date {
  display: block;
  width: 62px;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/all-scheme-analysis.vue